var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ScatterChartJs',{ref:"chart",attrs:{"height":_vm.height,"chartdata":_vm.chartdata}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }